import React from 'react'

export const Alert = ({ message, fixed }) => {
  return (
    <div className={`ssa__alert ${fixed ? 'ssa__alert--fixed' : ''}`}>{message}</div>
  )
}
